import { render } from "./LabelsView.vue?vue&type=template&id=94c9b130"
import script from "./LabelsView.vue?vue&type=script&lang=js"
export * from "./LabelsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__